import React, { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { Button, Form, Input, message } from "antd";
import { httpService } from "../../../services/httpService.service";
import "./styles.scss";
import MessagePopUp from "../../components/Messages/MessagePopUp";
import Done from "../../../Assets/svg/done.svg";
import exclamationMark from "../../../Assets/svg/exclamationMark.svg";
import { useForm } from "antd/es/form/Form";

const ForgetPasswordCode = () => {
  const [form] = useForm();
  const [confLoader, setConfLoader] = useState(false);
  const [resendTimer, setResendTimer] = useState(false);
  const [countdown, setCountdown] = useState(60);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const email = location.state?.email;
  const [message, setMessage] = useState({
    trigger: false,
    type: "",
    icon: "",
    title: "",
    text: "",
  });

  const handleVerify = async () => {
    setLoading(true);
    form
      .validateFields()
      .then((values) => {
        httpService.post(
          "/api/Account/confirmCode",
          {
            email,
            ...(values.code ? { code: values.code } : {}),
            changeOrForgotPasswordConfirmation: true,
          },
          (res) => {
            setLoading(false);
            setMessage({
              trigger: true,
              type: "success",
              icon: Done,
              title: "Confirmation!",
              text: "Code verified!",
            });
            setTimeout(() => {
              setMessage({
                trigger: false,
              });
            }, 3000);
            navigate("/newPassword", { state: { email } });
          },
          (error) => {
            setLoading(false);
            const errorMessage = error?.errors?.[0]?.message || error?.message;

            setMessage({
              trigger: true,
              type: "danger",
              icon: exclamationMark,
              title: "Oops! A problem has occurred!",
              text: errorMessage || "Invalid code!",
            });
            setTimeout(() => {
              setMessage({
                trigger: false,
              });
            }, 3000);
          }
        );
      })
      .catch(() => {
        setLoading(false);
        setMessage({
          trigger: true,
          type: "danger",
          icon: exclamationMark,
          title: "Oops! A problem has occurred!",
          text: "Please enter a valid code.",
        });
        setTimeout(() => setMessage({ trigger: false }), 3000);
      });
  };

  const handleResendCode = (e) => {
    e.preventDefault();
    setConfLoader(true);
    setResendTimer(true);
    setCountdown(60);

    const countdownInterval = setInterval(() => {
      setCountdown((prev) => {
        if (prev <= 1) {
          clearInterval(countdownInterval);
          setResendTimer(false);
          return 60;
        }
        return prev - 1;
      });
    }, 1000);

    httpService.get(
      `/api/Account/resendCode?email=${email}`,
      (res) => {
        setConfLoader(false);
        setMessage({
          trigger: true,
          type: "success",
          icon: Done,
          title: "Confirmation!",
          text: res?.message || "Verification code resent to your email.",
        });
        setTimeout(() => setMessage({ trigger: false }), 3000);
      },
      (error) => {
        setConfLoader(false);
        setMessage({
          trigger: true,
          type: "danger",
          icon: exclamationMark,
          title: "Oops! A problem has occurred!",
          text:
            error?.errors?.[0]?.message ||
            error?.message ||
            "Failed to resend code.",
        });
        setTimeout(() => setMessage({ trigger: false }), 3000);
      }
    );
  };

  return (
    <div className="wrapper">
      <div className="row">
        <div className="col-md-6 left-column">
          <img
            src="/assets/svg/LoginImage.svg"
            alt="Login Visual"
            className="leftImage"
          />
        </div>
        <MessagePopUp
          trigger={message.trigger}
          type={message.type}
          icon={message.icon}
          messageTitle={message.title}
          messageText={message.text}
        />
        <div className="col-md-6 right-column">
          <div className="form-wrapper1">
            <h2 className="verificationCodeHeader">Verification Code</h2>
            <p className="verificationCodeText">
              Please enter the verification code that we sent to {email}
            </p>
            <Form
              form={form}
              layout="vertical"
              className="w-100 d-flex flex-column align-items-center justify-content-center"
            >
              <div className="OTP w-100 d-flex justify-content-center">
                <Form.Item
                  name="code"
                  className=" text-center"
                  rules={[
                    {
                      required: true,
                      message: "Code is required",
                    },
                    {
                      pattern: /^\d{6}$/,
                      message: "Code must be exactly 6 digits",
                    },
                  ]}
                >
                  <Input.OTP
                    type="number"
                    maxLength={6}
                    placeholder="Enter code"
                  />
                </Form.Item>
              </div>

              <div className="d-flex flex-column buttonsModal w-100 mt-4">
                <Button
                  className="addButtonTPM w-50 mx-auto"
                  key="submit"
                  type="primary"
                  onClick={handleVerify}
                  loading={loading || confLoader}
                  disabled={loading}
                >
                  {loading
                    ? "Verifying code..."
                    : confLoader
                    ? "Sending code..."
                    : "Verify code"}
                </Button>
                {resendTimer ? (
                  <span className="w-100 text-center" style={{ color: "#999" }}>
                    Please wait {countdown}s
                  </span>
                ) : (
                  <p className="verificationCodeText">
                    If you didn’t receive a verification code,{" "}
                    <span
                      style={{ color: "#E164A0", cursor: "pointer" }}
                      onClick={handleResendCode}
                    >
                      click here to resend it
                    </span>{" "}
                    or send us an email at info@kaptechgroup.com
                  </p>
                )}
              </div>
            </Form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ForgetPasswordCode;
